/** @jsx jsx */
import React from 'react';
import { cssMap, jsx } from '@compiled/react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { Pressable } from '@atlaskit/primitives/compiled';
import { N600 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

type CircleButtonProps = {
	count: number;
	onClick: (event: React.MouseEvent, analyticsEvent?: UIAnalyticsEvent) => void;
};

const styles = cssMap({
	button: {
		width: '24px',
		height: '24px',
		paddingTop: token('space.0', '0'),
		paddingRight: token('space.0', '0'),
		paddingBottom: token('space.0', '0'),
		paddingLeft: token('space.0', '0'),
		overflow: 'hidden',
		font: token('font.body.small'),
		color: token('color.text.subtle', N600),
		backgroundColor: token('color.background.neutral'),
		borderRadius: token('border.radius.circle'),
		textAlign: 'center',
		'&:hover': {
			backgroundColor: token('color.background.neutral.hovered'),
		},
	},
});

const UnshownCount = ({ count, onClick }: CircleButtonProps) => {
	const { formatMessage } = useIntl();

	return (
		<Pressable
			onClick={onClick}
			xcss={styles.button}
			aria-label={formatMessage(messages.openModalButtonAriaLabel)}
		>
			{`+${count}`}
		</Pressable>
	);
};

export default UnshownCount;
